/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptProcessingOutcome =
    (typeof DocumentProcessingReceiptProcessingOutcome)[keyof typeof DocumentProcessingReceiptProcessingOutcome];

export const DocumentProcessingReceiptProcessingOutcome = {
    Completed: 'Completed',
    Partial: 'Partial',
    Failed: 'Failed',
    NotRequired: 'NotRequired',
} as const;
